import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { BrochureContentService } from '@app/service/brochure-content.service';
import { MeetTheTeamContent } from '@app/@models/brochure-content.model';

@Component({
  selector: 'app-meet-the-team',
  templateUrl: './meet-the-team.component.html',
  styleUrls: ['./meet-the-team.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MeetTheTeamComponent implements OnInit {
  private brochureContentService: BrochureContentService = inject(BrochureContentService);

  public content: MeetTheTeamContent | null = null;

  public async ngOnInit(): Promise<void> {
    this.content = (await this.brochureContentService.getBrochureContent()).meetTheTeam;
  }
}
